import React from "react";
import { Link } from "react-router-dom";

const Relaxation8 = () => {
  return (
    <div>
      <section className="bg-[#F5F5F5] h-screen shadow-[0_3px_10px_rgb(0,0,0,0.2)] m-4 rounded-md">
        <main className="px-6 py-6  rounded-lg border mt-6 mb-6 mr-12">
          <div>
            <h1 className="text-[30px] font-bold text-[#314C1C]">RELAXATION</h1>
            <div className="pt-4">
              <h2 className="text-[18px] font-semibold">EXERCISE CANCELLED</h2>
            </div>
            <div className="pt-4">
              <p>
                No problem, you can chose to start a new exercise whenever
                you're ready, <br />
                taking care of your mental well-being is important
              </p>
            </div>
          </div>
          <div className="mt-6 mb-6 flex flex-col items-center">
            <div className="w-96 flex justify-center items-center">
              <img
                src="https://res.cloudinary.com/dmvphwhvc/image/upload/v1701178680/ltlwwwjrghhcgjkuscgh.png"
                alt
                className="w-full max-w-screen-xl"
              />
            </div>
            <div className="mt-4 space-y-2">
              <Link to="../relaxation5">
                <button className="px-8 py-2 bg-[#295700] rounded text-[#fff]">
                  Restart
                </button>
              </Link>
              <Link to="../relaxation23">
                <button className="px-4 py-2 bg-[#295700] rounded text-[#fff] ml-8">
                  Start Another Exercise
                </button>
              </Link>
            </div>
            <div className="flex mt-7">
              <img
                src="https://res.cloudinary.com/dmvphwhvc/image/upload/v1701178678/xwkwlvput0im1owlgp9y.png"
                alt="Home"
                className
              />
            </div>
          </div>
        </main>
      </section>
    </div>
  );
};

export default Relaxation8;
